import { Column, Grid } from './Grid'
import peters_photo from '@/public/images/peters_photo.jpg'
import Image from 'next/image'
import { Headline } from './Headline'
import { Container } from './Container'
import { imageLoader } from '@/loaders/index'

export function CoachSection({
  className = ''
}) {
  return (
    <section className={className} id="your-tutor">
      <Container withPattern>
        <Grid className="py-[90px] pb-[120px] md:py-[120px] flex-col md:flex-row">
          <Column className="md:w-[80%] relative">
            <span className="hidden md:block absolute left-0 bottom-0 h-[1px] w-[calc(100%-80px)] bg-black"></span>
            <Grid className="flex-col md:flex-row">
              <Column className="md:w-[25%]">
                <Headline tag="h2" className="text-[40px] mb-[30px] md:mb-0 md:text-[56px] leading-[1.1]">Your <span className='font-accent font-thin text-[48px] md:text-[60px]'>Coach</span></Headline>
              </Column>
              <Column className="md:w-[75%] pr-[80px]">
                <div>
                  <p className="mb-[30px]">I’m Peter Shallard, Shrink for Entrepreneurs and Founder of Commit Action. For over 15 years, I’ve served as a behind-the-scenes confidante and advisor to some of the world’s most effective startup founders. My clients have collectively raised hundreds of millions of venture capital, created market capitalization of several billion and lifestyles of terrific freedom and accomplishment.</p>
                  <p>My own startup, Commit Action, developed the world’s best accountability coaching and evidence-based planning methodology. Commit Action has scientifically boosted productivity for over eight thousand entrepreneurs, in over 60 countries and across hundreds of industries. Scientific Productivity breaks down our system—for the first time ever—in a do-it-yourself course.</p>
                </div>
              </Column>
            </Grid>
          </Column>
          <Column className="md:w-[20%] shrink-0 pt-[30px] md:pt-[60px] relative">
            <div className="ml-auto md:ml-0 w-[60%] md:w-auto">
              <Image
                src={peters_photo}
                alt="Peter's photo"
                loader={imageLoader}
              />
            </div>
            <span className="md:hidden absolute left-0 bottom-[-30px] h-[1px] w-full bg-black"></span>
          </Column>
        </Grid>
      </Container>
    </section>
  )
}
